module.exports = __webpack_public_path__ + "static/media/flash-yellow.130326e1.svg";